// @flow
import React, {
  type Element,
  // $FlowFixMe
  type UIEvent,
  // $FlowFixMe
  useMemo,
  // $FlowFixMe
  useContext,
  // $FlowFixMe
  useState,
  // $FlowFixMe
  useEffect,
  // $FlowFixMe
  useCallback
} from "react";
// $FlowFixMe
import loadable from "@loadable/component";

import { get, throttle } from "lodash";

import ApolloContext from "@tvg/utils/apolloContext";
import type { RouterHistory } from "react-router-dom";
import type { Dispatch } from "redux";
import mediator from "@tvg/mediator";
import Button from "@fdr/atomic-ui/_atoms/Button";
import Toast from "@fdr/atomic-ui/_atoms/Toast";
import ModalV2 from "@fdr/atomic-ui/_templates/ModalV2";
import { Modal } from "@tvg/design-system";
import type { NullaryFn } from "@tvg/types/Functional";
import GeoComplyError from "@fdr/atomic-ui/_templates/GeoComplyError";
import InvalidResidentialAddressError from "@fdr/atomic-ui/_templates/InvalidResidentialAddressError";
import PotencialReturnHelp from "@fdr/potencial-return-help";
import PickBetsHowItWorks from "@fdr/pick-bets-how-it-works";
import Message from "@fdr/atomic-ui/_molecules/Message";
import FeatureToggles from "@tvg/toggles";
import { closeMyBets } from "@fdr/my-bets/src/actions";
import { isXSell, isMobile } from "@tvg/sh-utils/mobileUtils";
import { useActiveBets, useSettledBets } from "@urp/my-bets/hooks";
import type { UserOptedInPromos } from "@tvg/types/User";
import type { Product, Device } from "@tvg/conf/src/types";
import type { MapFeatureToggles } from "@tvg/types/Product";
import {
  ErrorMessage,
  MapImageEnum,
  ErrorDescription
} from "@tvg/ts-types/GeoComply";
import type { RaceProgram } from "@tvg/types/Race";
import {
  closeHandicappingStoreModal,
  setHandicappingStoreModalHeader
} from "@tvg/shared-actions/HandicappingStore";
import UpcomingRaces from "@fdr/upcoming-races";
import RaceSelectorList from "@fdr/race-selector-list";
import type { GeolocationStatus } from "@fdr/types/GeoLocation";
import { geolocationStatusClear } from "@tvg/sh-geolocation/src/redux/actions";
import { FeedbackMessageContext } from "@fdr/utils/contextUtils";
import { logout } from "@tvg/sh-lib-account-wallet/src/session/logout";
import { LogoFDR } from "@fdr/static-ui/Logos";

import {
  closeApproxPayoutModal,
  closeBetCancelModal,
  closeMyBetsStandalone
} from "@tvg/sh-lib-my-bets/redux/actions";
import MyBetsModalURP from "@urp/my-bets/components/modals/mybets";
import ApproxPayoutHelpComp from "@tvg/approx-payout-help";
import BetCancel from "@tvg/bet-cancel";
import { TransactionHistory } from "@urp/transaction-history";
import ApolloContextClients from "@tvg/utils/types/ApolloContext";
import {
  closePromosModal,
  closeBetPrefsModal,
  closeNavigationModal,
  closeFeatureTogglesModal,
  closeTrackSelectorModal,
  closeRaceSelectorModal,
  closeSupportModal,
  closeWelcomeNewUserModal,
  closeHelpModal,
  closePotencialReturnModal,
  closePickBetsHowItWorksModal,
  closeInvalidResidentialAddressModal
} from "../../actions/modals";

import styles from "../style/styles.css";

import type { TransitionState } from "../../types";

const MyBets = loadable(() =>
  import(/* webpackChunkName: 'MyBetsModal' */ "./MyBets")
);
const BetPrefs = loadable(() =>
  import(/* webpackChunkName: 'BetPreferencesModal' */ "./BetPreferences")
);
const Promos = loadable(() =>
  import(/* webpackChunkName: 'PromosModal' */ "./Promos")
);
const HandicappingStore = loadable(() =>
  import(/* webpackChunkName: 'HandicappingStoreModal' */ "./HandicappingStore")
);
const CrossProductNavigation = loadable(() =>
  import(
    /* webpackChunkName: 'CrossProductNavigationModal' */ "./CrossProductNavigation"
  )
);
const HelpModal = loadable(() =>
  import(/* webpackChunkName: 'helpModal' */ "@fdr/program-page-help")
);
const Support = loadable(() =>
  import(/* webpackChunkName: 'supportModal' */ "@fdr/support")
);

type ModalTopChildrenProps = {
  isFullHeightModal?: boolean,
  toastCallback?: NullaryFn<mixed>
};

export const ModalTopChildren = ({
  isFullHeightModal,
  toastCallback
}: ModalTopChildrenProps) => {
  const { toastProps } = useContext(FeedbackMessageContext);
  return toastProps.showToast ? (
    <Toast
      {...toastProps}
      noAnimation={toastProps.isMessageShown}
      renderBottom={isFullHeightModal}
      isTopPosition={isFullHeightModal}
      callback={toastCallback}
    />
  ) : null;
};

export const MyBetsModal = ({
  title,
  subtitle,
  isVideoShown,
  isOpen,
  qaLabel,
  dispatch,
  currentPath,
  currentRace,
  history,
  device,
  myBetsStandaloneToggle,
  activeBetsNumber = 0,
  isActiveBetsModal,
  useCloseLabel,
  hideFixedBanner,
  isPastPerformanceOpen,
  pastPerformanceTitle,
  selectedTab,
  selectedSettledTab,
  activeBetsCounter,
  settledBetsCounter,
  futureBetsCounter,
  activeWageredAmount,
  settledWageredAmount,
  myBetsCounterToggle,
  futureWageredAmount
}: {
  title: string,
  subtitle?: string,
  isVideoShown: boolean,
  isOpen: boolean,
  qaLabel: string,
  dispatch: Dispatch<*>,
  currentPath: string,
  currentRace: RaceProgram,
  history: RouterHistory,
  device: Device,
  activeBetsNumber?: number,
  isActiveBetsModal: boolean,
  useCloseLabel?: boolean,
  hideFixedBanner?: boolean,
  myBetsStandaloneToggle: boolean,
  isPastPerformanceOpen: boolean,
  pastPerformanceTitle: string,
  selectedTab: string,
  selectedSettledTab: string,
  activeBetsCounter: number,
  settledBetsCounter: number,
  futureBetsCounter: number,
  activeWageredAmount: number,
  settledWageredAmount: number,
  myBetsCounterToggle: boolean,
  futureWageredAmount: number
}) => {
  const [modalScrollableRef, setModalScrollableRef] = useState(null);
  const [scrollYPosition, setScrollYPosition] = useState(0);
  const setModalScrollableRefCallback = useCallback((node) => {
    setModalScrollableRef(node);
  }, []);
  const onMyBetsScroll = throttle(
    (scrollEvent: UIEvent<HTMLElement>) => {
      if (myBetsStandaloneToggle) {
        setScrollYPosition(scrollEvent.nativeEvent.contentOffset.y);
      } else {
        setScrollYPosition(scrollEvent.currentTarget.scrollTop);
      }
    },
    1000,
    {
      trailing: false
    }
  );

  useActiveBets();
  useSettledBets();

  if (myBetsStandaloneToggle) {
    const baseProps = {
      currentPath,
      isPastPerformanceOpen,
      isVideoShown,
      pastPerformanceTitle,
      title: isPastPerformanceOpen ? pastPerformanceTitle : title,
      selectedTab,
      selectedSettledTab,
      settledBetsCounter,
      settledWageredAmount,
      futureBetsCounter,
      futureWageredAmount,
      activeBetsCounter,
      activeWageredAmount,
      myBetsCounterToggle,
      qaLabel,
      isOpen,
      history
    };

    return (
      <MyBetsModalURP
        {...baseProps}
        onScroll={({ ref, event }) => {
          setModalScrollableRefCallback(ref);
          onMyBetsScroll(event);
        }}
      >
        <MyBets
          device={device}
          myBetsStandaloneToggle
          modalScrollableRef={modalScrollableRef}
          scrollYPosition={scrollYPosition}
        />
      </MyBetsModalURP>
    );
  }

  useEffect(() => {
    const hash = history?.location?.hash || "";
    if (isOpen && !hash.includes("#my-bets")) {
      dispatch(closeMyBetsStandalone());
    }
  }, [history?.location?.hash]);

  const closeMyBetsModal = () => {
    history.push(currentPath);
    dispatch(closeMyBets());

    if (isActiveBetsModal) {
      mediator.base.dispatch({ type: "RACE_ACTIVE_BETS_MODAL_CLOSE" });
    } else {
      mediator.base.dispatch({ type: "MYBETS_MODAL_CLOSE_FDR" });
    }
  };

  const ModalFooter = isActiveBetsModal ? (
    <Button
      type="subTab"
      isStretched
      onClick={() => {
        dispatch(closeMyBets());

        mediator.base.dispatch({
          type: "RACE_ACTIVE_BETS_MODAL_RETURN",
          payload: {
            trackName: get(currentRace, "track.shortName"),
            raceNumber: get(currentRace, "raceNumber"),
            mtp: get(currentRace, "mtp"),
            destinationUrl: currentPath
          }
        });
      }}
    >
      Return to Racecard
    </Button>
  ) : null;

  const baseProps = {
    title,
    subtitle,
    titleType: "default",
    isOpen,
    onClose: closeMyBetsModal,
    isFullHeight: true,
    qaLabel,
    hasShadow: true,
    displayZeroTitleBadge: !!activeBetsNumber,
    titleBadgeNumber: activeBetsNumber,
    footer: ModalFooter,
    useCloseLabel,
    hideFixedBanner,
    modalTopChildren: () => (
      <ModalTopChildren
        isFullHeightModal
        toastCallback={() => dispatch(geolocationStatusClear())}
      />
    )
  };

  const props =
    device === "mobile"
      ? {
          ...baseProps,
          animation: "bottom",
          hasOverlay: !isVideoShown,
          hasVideoOffset: isVideoShown,
          onScrollFn: onMyBetsScroll
        }
      : {
          ...baseProps,
          animation: "right",
          hasOverlay: true,
          isFullWidth: false,
          hasRoundedCorners: false,
          offsetTop: 0
        };

  return useMemo(() => (
    <ModalV2
      {...props}
      setScrollableRef={setModalScrollableRefCallback}
      scrollableRef={{ current: modalScrollableRef }}
    >
      {(transitionState: TransitionState) => (
        <MyBets
          transitionState={transitionState}
          device={device}
          myBetsStandaloneToggle={false}
          modalScrollableRef={modalScrollableRef}
          scrollYPosition={scrollYPosition}
        />
      )}
    </ModalV2>
  ));
};

export const PromosModal = ({
  isVideoShown,
  isOpen,
  dispatch,
  isLogged,
  currentPath,
  history,
  promoPage,
  device,
  accountNumber,
  optedInPromos,
  homeState
}: {
  isVideoShown: boolean,
  isOpen: boolean,
  dispatch: Dispatch<*>,
  isLogged: boolean,
  currentPath: string,
  history: RouterHistory,
  promoPage: string,
  device: Device,
  accountNumber: string,
  optedInPromos: UserOptedInPromos,
  homeState: string
}) => {
  const closePromos = () => {
    const promosPath = currentPath.split("promo=");
    const currentPage = promosPath[1]
      ? promosPath[0].slice(0, -1)
      : currentPath;
    history.push(currentPage);
    dispatch(closePromosModal());

    if (typeof window !== "undefined") {
      document.title = JSON.parse(window.seoData).title;
    }
  };

  const baseProps = {
    title: "Promotions",
    titleType: "default",
    isOpen,
    onClose: closePromos,
    isFullHeight: true,
    qaLabel: "modal-promos",
    modalTopChildren: () => (
      <ModalTopChildren
        isFullHeightModal
        toastCallback={() => dispatch(geolocationStatusClear())}
      />
    )
  };

  const props =
    device === "mobile"
      ? {
          ...baseProps,
          animation: "bottom",
          hasVideoOffset: isVideoShown
        }
      : {
          ...baseProps,
          animation: "fade",
          hasOverlay: true,
          offsetTop: 40,
          offsetBottom: 0,
          offsetLeft: 40,
          offsetRight: 40
        };

  return useMemo(() => (
    <ModalV2 {...props}>
      {(transitionState: TransitionState) => (
        <Promos
          isLogged={isLogged}
          currentPath={currentPath}
          transitionState={transitionState}
          dispatch={dispatch}
          promoPage={promoPage}
          accountNumber={accountNumber}
          optedInPromos={optedInPromos}
          homeState={homeState}
          history={history}
        />
      )}
    </ModalV2>
  ));
};

export const BottomSwipeModal = ({
  isOpen,
  dispatch,
  currentPath,
  history,
  title,
  content,
  device,
  isScrollAfterLoad,
  hideFixedBanner
}: {
  isOpen: boolean,
  dispatch: Dispatch<*>,
  currentPath: string,
  history: RouterHistory,
  title: string,
  content: Element<*>,
  device: Device,
  // eslint-disable-next-line
  isScrollAfterLoad?: boolean,
  hideFixedBanner?: boolean
}) => {
  const closeTutorials = () => {
    history.push(currentPath);
    dispatch(closeNavigationModal());
    mediator.base.dispatch({
      type: "MORE_CLOSE_CONTENT",
      payload: {
        destinationMenu: "More Menu",
        module: "tutorials"
      }
    });
  };

  if (typeof window !== "undefined" && isScrollAfterLoad)
    setTimeout(() => {
      const { hash } = window.location;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView();
        }
      }
    }, 0);

  const qaLabel = `modal-${title.split(" ")[0]}` || "modal-legalOptions";
  const baseProps = {
    title,
    titleType: "default",
    isOpen,
    onClose: closeTutorials,
    isFullHeight: true,
    qaLabel,
    hasRoundedCorners: true,
    hasOverlay: true,
    offsetTop: 16,
    animation: "bottom",
    hideFixedBanner,
    modalTopChildren: () => (
      <ModalTopChildren
        isFullHeightModal
        toastCallback={() => dispatch(geolocationStatusClear())}
      />
    )
  };

  const props =
    device === "mobile"
      ? baseProps
      : {
          ...baseProps,
          isFullWidth: false
        };

  return useMemo(() => <ModalV2 {...props}>{() => content}</ModalV2>);
};

export const TrackSelectorModal = ({
  dispatch,
  isOpen,
  history,
  currentPath
}: {
  dispatch: Dispatch<*>,
  isOpen: boolean,
  history: RouterHistory,
  currentPath: string
}) => {
  const closeTrackSelector = () => {
    history.push(currentPath);
    dispatch(closeTrackSelectorModal());
  };

  const baseProps = {
    title: "Upcoming Races",
    isSubTitleUppercase: false,
    titleType: "default",
    isOpen,
    onClose: closeTrackSelector,
    isFullHeight: false,
    animation: "bottom",
    qaLabel: "modal-track-selector",
    modalTopChildren: () => (
      <ModalTopChildren
        toastCallback={() => dispatch(geolocationStatusClear())}
      />
    )
  };

  return useMemo(() => (
    <ModalV2 {...baseProps} hasShadow={false}>
      {() => (
        <ApolloContext.Consumer>
          {(value) => (
            <UpcomingRaces
              key="UPCOMING_RACES_TRACK_SELECTOR"
              title=""
              device="mobile"
              shouldUpdate
              rdaClient={value.rdaClient}
            />
          )}
        </ApolloContext.Consumer>
      )}
    </ModalV2>
  ));
};

export const RaceSelectorModal = ({
  dispatch,
  isOpen,
  history,
  currentPath,
  trackTitle,
  numberOfRaces
}: {
  dispatch: Dispatch<*>,
  isOpen: boolean,
  history: RouterHistory,
  currentPath: string,
  trackTitle: string,
  numberOfRaces: number
}) => {
  const closeRaceSelector = () => {
    history.push(currentPath);
    dispatch(closeRaceSelectorModal());
  };

  const baseProps = {
    title: trackTitle,
    subtitle: `${numberOfRaces} races`,
    isSubTitleUppercase: false,
    titleType: "default",
    isOpen,
    onClose: closeRaceSelector,
    isFullHeight: false,
    animation: "bottom",
    qaLabel: "modal-track-race-selector",
    modalTopChildren: () => (
      <ModalTopChildren
        isFullHeightModal={numberOfRaces > 7}
        dispatch={dispatch}
      />
    )
  };

  return useMemo(() => (
    <ModalV2 {...baseProps}>{() => <RaceSelectorList />}</ModalV2>
  ));
};

export const HelpOpenModal = ({
  dispatch,
  isOpen,
  history,
  currentPath
}: {
  dispatch: Dispatch<*>,
  isOpen: boolean,
  history: RouterHistory,
  currentPath: string
}) => {
  const hashMap = {
    "#understandingOdds": {
      type: "understanding odds",
      templateType: "tutorial"
    },
    "#understandingPools": {
      type: "understanding pools",
      templateType: "tutorial"
    },
    "#understandingBetTypes": { type: "bet types", templateType: "betTypes" }
  };

  const newCurrentPath =
    currentPath === "/account" ? "/account#tutorials" : currentPath;

  const closeHelp = () => {
    history.push(newCurrentPath);
    dispatch(closeHelpModal());
  };

  return useMemo(() => (
    <HelpModal
      type={get(hashMap, `[${get(history, "location.hash")}].type`, "help")}
      templateType={get(
        hashMap,
        `[${get(history, "location.hash")}].templateType`
      )}
      isOpen={isOpen}
      closeModal={closeHelp}
      dispatch={dispatch}
    />
  ));
};

export const FeatureTogglesModal = ({
  dispatch,
  isOpen,
  device,
  history,
  currentPath
}: {
  dispatch: Dispatch<*>,
  isOpen: boolean,
  device: string,
  history: RouterHistory,
  currentPath: string,
  featureToggles: MapFeatureToggles
}) => {
  const closeToggles = () => {
    history.push(currentPath);
    dispatch(closeFeatureTogglesModal());
  };

  const baseProps = {
    title: "Feature Toggles",
    titleType: "default",
    isOpen,
    onClose: closeToggles,
    isFullHeight: true,
    qaLabel: "modal-featureToggles"
  };

  const props =
    device === "mobile"
      ? {
          ...baseProps,
          animation: "bottom"
        }
      : {
          ...baseProps,
          animation: "right",
          hasOverlay: true,
          isFullWidth: false,
          hasRoundedCorners: false,
          offsetTop: 0
        };

  return useMemo(() => (
    <ModalV2 {...props}>{() => <FeatureToggles />}</ModalV2>
  ));
};

export const BetPrefsModal = ({
  isOpen,
  dispatch,
  currentPath,
  history,
  title,
  device
}: {
  isOpen: boolean,
  dispatch: Dispatch<*>,
  currentPath: string,
  history: RouterHistory,
  title: string,
  device: Device
}) => {
  const closeBetPrefs = () => {
    history.push(currentPath);
    dispatch(closeBetPrefsModal());
    mediator.base.dispatch({
      type: "BET_PREFERENCES:NAVIGATE_MORE_PAGE",
      payload: { tag: "Back button" }
    });
  };

  const closeBetPrefsWithoutGtm = () => {
    history.push(currentPath);
    dispatch(closeBetPrefsModal());
  };

  const baseProps = {
    title,
    titleType: "navigation",
    isOpen,
    onClose: closeBetPrefs,
    isFullHeight: true,
    qaLabel: "modal-navigation",
    modalTopChildren: () => (
      <ModalTopChildren
        isFullHeightModal
        toastCallback={() => dispatch(geolocationStatusClear())}
      />
    )
  };

  const props =
    device === "mobile"
      ? {
          ...baseProps,
          animation: "right",
          hasOverlay: false,
          offsetTop: 0
        }
      : {
          ...baseProps,
          animation: "right",
          hasOverlay: true,
          isFullWidth: false,
          hasRoundedCorners: false,
          offsetTop: 0
        };

  return useMemo(() => (
    <ModalV2 {...props}>
      {(transitionState: TransitionState) => (
        <BetPrefs
          transitionState={transitionState}
          device={device}
          closeModal={closeBetPrefsWithoutGtm}
        />
      )}
    </ModalV2>
  ));
};

export const HandicapStoreModal = ({
  isVideoShown,
  isOpen,
  dispatch,
  currentPath,
  history,
  device,
  product,
  iFrameUrl,
  className,
  hasHeader,
  errorMessage
}: {
  isVideoShown: boolean,
  isOpen: boolean,
  dispatch: Dispatch<*>,
  currentPath: string,
  history: RouterHistory,
  device: Device,
  product: Product,
  iFrameUrl: string,
  className: string,
  hasHeader: boolean,
  errorMessage: string
}) => {
  const closeHandicapingStore = () => {
    history.push(currentPath);
    dispatch(closeHandicappingStoreModal());
    dispatch(setHandicappingStoreModalHeader(true));
  };

  const baseProps = {
    title: "Handicapping Store",
    titleType: "default",
    hasHeader,
    isOpen,
    onClose: closeHandicapingStore,
    isFullHeight: true,
    qaLabel: "modal-handicapping-store",
    useFakeInput: device === "tablet" && isMobile(product),
    modalTopChildren: () => (
      <ModalTopChildren
        isFullHeightModal
        toastCallback={() => dispatch(geolocationStatusClear())}
      />
    )
  };

  const props =
    device === "mobile"
      ? {
          ...baseProps,
          animation: "bottom",
          hasVideoOffset: isVideoShown
        }
      : {
          ...baseProps,
          animation: "fade",
          hasOverlay: true,
          offsetTop: 40,
          offsetBottom: 0,
          offsetLeft: 40,
          offsetRight: 40
        };

  return useMemo(() => (
    <ModalV2 {...props}>
      {() => (
        <div className={className}>
          <HandicappingStore
            iFrameUrl={iFrameUrl}
            iframeClass={styles.iframeContent}
            dispatch={dispatch}
            errorMessage={errorMessage}
          />
        </div>
      )}
    </ModalV2>
  ));
};

export const SupportModal = ({
  isOpen,
  dispatch,
  currentPath,
  history
}: {
  isOpen: boolean,
  dispatch: Dispatch<*>,
  currentPath: string,
  history: RouterHistory
}) => {
  const closeSupport = () => {
    history.push(currentPath);
    dispatch(closeSupportModal());
    mediator.base.dispatch({
      type: "SUPPORT_MODAL_TOGGLE",
      payload: {
        modalToggle: "close"
      }
    });
  };

  const baseProps = {
    title: "Support",
    titleType: "default",
    isOpen,
    onClose: closeSupport,
    isFullHeight: false,
    qaLabel: "modal-support",
    hasShadow: true,
    modalTopChildren: () => (
      <ModalTopChildren
        toastCallback={() => dispatch(geolocationStatusClear())}
      />
    )
  };

  const props = { ...baseProps, animation: "bottom" };

  return useMemo(() => (
    <ModalV2 {...props}>
      {(transitionState: TransitionState) => (
        <Support
          currentPath={currentPath}
          transitionState={transitionState}
          onOpenLiveChat={closeSupport}
        />
      )}
    </ModalV2>
  ));
};

export const WelcomeNewUserModal = ({
  isOpen,
  dispatch,
  currentPath,
  history,
  device,
  userEmail
}: {
  isOpen: boolean,
  dispatch: Dispatch<*>,
  currentPath: string,
  history: RouterHistory,
  device: Device,
  userEmail: string
}) => {
  const closeWelcomeNewUser = () => {
    sessionStorage.removeItem("newUser");
    history.push(currentPath);
    dispatch(closeWelcomeNewUserModal());
    mediator.base.dispatch({ type: "FDR_CLOSE_WELCOME_MODAL" });
  };

  const baseProps = {
    title: "Fund your account",
    titleType: "default",
    isOpen,
    onClose: closeWelcomeNewUser,
    qaLabel: "modal-welcome-new-user",
    offsetTop: 0,
    isFullHeight: false,
    hasShadow: true,
    hasBottomCorners: true,
    modalTopChildren: () => (
      <ModalTopChildren
        toastCallback={() => dispatch(geolocationStatusClear())}
      />
    )
  };
  const props =
    device === "mobile"
      ? {
          ...baseProps,
          animation: "bottomFloating",
          isFullWidth: false,
          offsetRight: 8,
          offsetLeft: 8
        }
      : {
          ...baseProps,
          isFullWidth: false,
          animation: "fade"
        };

  return useMemo(() => (
    <ModalV2 {...props}>
      {() => (
        <div style={{ padding: `12px`, background: `#fff` }}>
          <Message
            logoAtStart
            type="success"
            size="small"
            text="Account Created!"
            subText={`We've sent an email with account details to ${
              userEmail || "your email"
            }`}
          />
        </div>
      )}
    </ModalV2>
  ));
};

export const PotencialReturnModal = ({
  isOpen,
  hasMessage,
  parentPage,
  dispatch,
  currentPath
}: {
  isOpen: boolean,
  hasMessage: boolean,
  parentPage: string,
  dispatch: Dispatch<*>,
  currentPath: string
}) => {
  const closePotentialReturn = () => {
    dispatch(closePotencialReturnModal());
    mediator.base.dispatch({
      type: "POTENCIAL_RETURN_MODAL_TOGGLE",
      payload: {
        modalToggle: "close"
      }
    });
  };

  const baseProps = {
    title: "Potential Returns",
    titleType: "default",
    isOpen,
    onClose: closePotentialReturn,
    isFullHeight: false,
    qaLabel: "modal-potencial-return",
    hasShadow: true,
    modalTopChildren: () => (
      <ModalTopChildren
        toastCallback={() => dispatch(geolocationStatusClear())}
      />
    )
  };

  const props =
    parentPage === "myBets"
      ? {
          ...baseProps,
          offsetRight: 12,
          offsetLeft: 12,
          animation: "bottomFloating",
          hasBottomCorners: true
        }
      : {
          ...baseProps,
          animation: "bottom"
        };

  return useMemo(() => (
    <ModalV2 {...props}>
      {(transitionState: TransitionState) => (
        <PotencialReturnHelp
          hasMessage={hasMessage}
          currentPath={currentPath}
          transitionState={transitionState}
        />
      )}
    </ModalV2>
  ));
};

export const PickBetsHowItWorksModal = ({
  isOpen,
  dispatch,
  currentPath,
  history
}: {
  isOpen: boolean,
  history: RouterHistory,
  dispatch: Dispatch<*>,
  currentPath: string
}) => {
  const closeHowItWorks = () => {
    mediator.base.dispatch({
      type: "PICK_BETS_ONBOARDING_CLOSE_MODAL",
      payload: { buttonCopy: "close" }
    });
    history.push(currentPath);
    dispatch(closePickBetsHowItWorksModal());
    mediator.base.dispatch({
      type: "PICK_BETS_HOW_IT_WORKS_MODAL_TOGGLE",
      payload: {
        modalToggle: "close"
      }
    });
  };

  const baseProps = {
    title: "Pick Bet Parlays",
    titleType: "default",
    isOpen,
    onClose: closeHowItWorks,
    isFullHeight: false,
    qaLabel: "pick-bets-how-it-works",
    hasShadow: true,
    modalTopChildren: () => (
      <ModalTopChildren
        toastCallback={() => dispatch(geolocationStatusClear())}
      />
    )
  };

  const props = {
    ...baseProps,
    animation: "bottom"
  };

  return useMemo(() => (
    <ModalV2 {...props}>
      {(transitionState: TransitionState) => (
        <PickBetsHowItWorks
          currentPath={currentPath}
          transitionState={transitionState}
          onClose={baseProps.onClose}
        />
      )}
    </ModalV2>
  ));
};

export const GeoComplyErrorModal = ({
  isOpen,
  title,
  onDismiss,
  errorsTitle,
  errorsMessages,
  imageType,
  onClickPrimaryButton,
  onClickSecondaryButton,
  geolocationStatus,
  errorDescription,
  isErrorRetryable
}: {
  isOpen: boolean,
  title: string,
  onDismiss: Function,
  errorsTitle?: string,
  imageType?: MapImageEnum,
  errorsMessages?: ErrorMessage[],
  onClickPrimaryButton?: Function,
  onClickSecondaryButton?: Function,
  geolocationStatus?: GeolocationStatus,
  errorDescription?: ErrorDescription,
  isErrorRetryable?: boolean
}) => {
  const baseProps = {
    title,
    isOpen,
    onDismiss,
    isFullHeight: true,
    hasHeader: false,
    offsetTop: 0,
    qaLabel: `modal-geoComply-error`,
    forceModalTop: true
  };

  const props = {
    ...baseProps,
    animation: "bottom"
  };

  return useMemo(() => (
    <ModalV2 {...props}>
      {(transitionState: TransitionState) => (
        <GeoComplyError
          isGenericError={geolocationStatus === "LOCATION_FAILURE"}
          transitionState={transitionState}
          title={title}
          onDismiss={onDismiss}
          imageType={imageType}
          errorsMessages={errorsMessages}
          errorsTitle={errorsTitle}
          primaryButton={
            isErrorRetryable && {
              title: "Retry",
              onClick: onClickPrimaryButton
            }
          }
          secondaryButton={
            !isErrorRetryable && {
              title: "Contact Support",
              onClick: onClickSecondaryButton
            }
          }
          description={errorDescription}
        />
      )}
    </ModalV2>
  ));
};

export const InvalidResidentialAddressErrorModal = ({
  isOpen,
  dispatch,
  errorMessages
}: {
  isOpen: boolean,
  dispatch: Dispatch<*>,
  errorMessages: string
}) => {
  const closeModal = () => {
    // $FlowFixMe
    logout();
    dispatch(closeInvalidResidentialAddressModal());
  };

  const baseProps = {
    title: "",
    titleType: "dark",
    icon: LogoFDR(30, "", "#FFFFFF"),
    offsetTop: 0,
    isOpen,
    useCloseLabel: true,
    hasRoundedCorners: false,
    onClose: closeModal,
    isFullHeight: true,
    qaLabel: "invalid-residential-address-error",
    hasShadow: true,
    modalTopChildren: () => (
      <ModalTopChildren
        toastCallback={() => dispatch(geolocationStatusClear())}
      />
    )
  };

  const props = {
    ...baseProps,
    animation: "bottom"
  };

  return useMemo(() =>
    isXSell() && isOpen ? (
      <InvalidResidentialAddressError
        isSplashScreen
        errorMessages={errorMessages}
      />
    ) : (
      <ModalV2 {...props}>
        {(transitionState: TransitionState) => (
          <InvalidResidentialAddressError
            transitionState={transitionState}
            onClose={baseProps.onClose}
            errorMessages={errorMessages}
          />
        )}
      </ModalV2>
    )
  );
};

export const CrossProductNavigationModal = ({
  isOpen,
  onClose
}: {
  isOpen: boolean,
  onClose: NullaryFn<void>
}) => {
  const baseProps = {
    title: "All Products",
    titleAlign: "center",
    titleType: "default",
    isOpen,
    onClose,
    isFullHeight: false,
    qaLabel: `modal-cross-product-navigation`,
    useCloseLabel: true,
    closeLabel: "Close",
    hideFixedBanner: true,
    forceModalTop: true
  };

  const props = {
    ...baseProps,
    animation: "bottom"
  };

  return (
    <ModalV2 {...props}>
      {(transitionState: TransitionState) => (
        <CrossProductNavigation transitionState={transitionState} isModal />
      )}
    </ModalV2>
  );
};

export const TransactionHistoryModal = ({
  isOpen,
  onClose
}: {
  isOpen: boolean,
  onClose: NullaryFn<void>
}) => {
  const baseProps = {
    title: "Transaction History",
    titleAlign: "center",
    titleType: "dark",
    isOpen,
    onClose,
    isFullHeight: true,
    qaLabel: `modal-transaction-history`,
    useCloseLabel: true,
    closeLabel: "Done",
    hideFixedBanner: true,
    forceModalTop: true
  };

  const props = {
    ...baseProps,
    animation: "bottom"
  };

  return (
    <ModalV2 {...props}>
      {(transitionState: TransitionState) => (
        <TransactionHistory
          transitionState={transitionState}
          onClose={onClose}
        />
      )}
    </ModalV2>
  );
};

export const BetCancelModal = ({
  isOpen,
  dispatch,
  isLoading,
  device,
  betCancelModalProcessingTitleLabel,
  betCancelModalConfirmTitleLabel
}: {
  isOpen: boolean,
  dispatch: Dispatch<*>,
  isLoading: boolean,
  device: string,
  betCancelModalProcessingTitleLabel: string,
  betCancelModalConfirmTitleLabel: string
}) => {
  const onClose = () => {
    dispatch(closeBetCancelModal({ result: { status: "aborted" } }));
  };

  const baseProps = {
    type: "lightbox",
    title: isLoading
      ? betCancelModalProcessingTitleLabel
      : betCancelModalConfirmTitleLabel,
    titleType: "ipp",
    isOpen,
    onAfterClose: onClose,
    qaLabel: "bet-cancel",
    padding: 0
  };

  const props =
    device === "mobile"
      ? {
          ...baseProps,
          animation: "bottomFloating",
          offsetTop: 10,
          offsetBottom: 10,
          offsetLeft: 8,
          offsetRight: 8
        }
      : {
          ...baseProps,
          animation: "fade",
          offsetTop: 40,
          offsetBottom: 0,
          offsetLeft: 40,
          offsetRight: 40
        };

  return (
    <Modal {...props}>
      <ApolloContext.Consumer>
        {(value: ApolloContextClients) => (
          <BetCancel behgClient={value.behgClient} />
        )}
      </ApolloContext.Consumer>
    </Modal>
  );
};

export const ApproxPayoutHelpModal = ({
  isOpen,
  dispatch,
  device,
  approximatePayoutModalTitleLabel
}: {
  isOpen: boolean,
  dispatch: Dispatch<*>,
  device: string,
  approximatePayoutModalTitleLabel: string
}) => {
  const onClose = () => {
    dispatch(closeApproxPayoutModal());
  };

  const baseProps = {
    type: "lightbox",
    title: approximatePayoutModalTitleLabel,
    titleType: "ipp",
    isOpen,
    onAfterClose: onClose,
    qaLabel: "approximate-payout-help-modal",
    padding: 0
  };

  const props =
    device === "mobile"
      ? {
          ...baseProps,
          animation: "bottomFloating",
          offsetTop: 200,
          offsetBottom: 200,
          offsetLeft: 8,
          offsetRight: 8
        }
      : {
          ...baseProps,
          animation: "fade",
          offsetTop: 40,
          offsetBottom: 0,
          offsetLeft: 40,
          offsetRight: 40
        };

  return (
    <Modal {...props}>
      <ApproxPayoutHelpComp />
    </Modal>
  );
};

export default {
  MyBetsModal,
  BetPrefsModal,
  PromosModal,
  BottomSwipeModal,
  TrackSelectorModal,
  SupportModal,
  WelcomeNewUserModal,
  HelpOpenModal,
  PotencialReturnModal,
  PickBetsHowItWorksModal,
  GeoComplyErrorModal,
  InvalidResidentialAddressErrorModal,
  CrossProductNavigationModal,
  BetCancelModal,
  ApproxPayoutHelpModal
};
